import React from "react";
import "./about.css";
import { Link } from "react-router-dom";
import a_img from "../images/15.jpg";
const About = () => {
  return (
    <div className="about_container">
      <h1>About us</h1>
      <div className="grid">
        <div className="left">
          <img src={a_img} alt="" />
        </div>
        <div className="right">
          <h4>The White Dental</h4>
          <p>
            Dr Sandeep Kumar Jangra is an astute clinician with a strong
            academic background having 15 years of rich experience in the field
            of dentistry. He holds a bachelors degree (BDS) from the well known
            Government Dental College, PGIMS ,Rohtak and masters (MDS) in
            Orthodontics and Dentofacial Orthopedics from the most prestigious
            medical institute of the country AIIMS, New Delhi.
          </p>
          <Link to="/about/explore_us" className="btn">
            explor more
          </Link>
        </div>
      </div>
    </div>
  );
};
export default About;
